const noop = () => {};
const identity = (x) => x;

export const Field = () => null;
export const FieldArray = () => null;
export const reduxForm = () => identity;
export const formValueSelector = () => () => undefined;
export const change = noop;
export const submit = noop;
export const SubmissionError = Error;
export const reducer = (state = {}) => state;
export default { Field, FieldArray, reduxForm, formValueSelector, change, submit, SubmissionError, reducer };
